import { renderComponent } from "./renderComponent";
export var renderNothing = renderComponent(null);
export default renderNothing;

//# sourceMappingURL=renderNothing.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/renderNothing.js
// module id = 219
// module chunks = 0